import {h, Fragment} from "preact"
import { useAppStateSelector, pick, useFacets, useProductFilters } from "@nosto/preact"
import { useEffect, useMemo, useState, useRef } from "preact/hooks"
import { nativePopularFilters } from "../../config"

import FilterList from "./FilterList"

export default function MobilePopularFilters({ filters }) {
    const { response } = useAppStateSelector(state => pick(state, "response"))
    const { facets } = useFacets();
    const { removeAll } = useProductFilters();
    const [ activeDropdown, setActiveDropdown ] = useState(null);
    const containerRef = useRef(null);
    const docCount = response.products?.total ?? 0

    useEffect(() => {
        window.document.body.style.overflow = (activeDropdown) ? "hidden" : ""
        return () => window.document.body.style.overflow = ""
    }, [ activeDropdown ])

    const handleDropdownChange = (id) => {
        if(id === activeDropdown) {
            // prevent aria errors
            document.querySelector(`#ns-dropdown-panel-${id}`).blur();
            document.querySelectorAll(`#ns-dropdown-panel-${id} *`).forEach(el => el.blur());
        }
        setActiveDropdown(id !== activeDropdown ? id : null)
    }

    let finalFacets = nativePopularFilters;

    let filterTemplateFacets = document.getElementById('filter-template-data') ?? null;
    if(filterTemplateFacets) {
        let newFilters = JSON.parse(filterTemplateFacets.dataset.filterTemplate);
        if(newFilters.featured_filters != undefined) {
            finalFacets = newFilters.featured_filters;
        }
    }

    if(!finalFacets.length) return (<></>)
    
    return (
        <>
            <div class="pl-pagemargin pt-sm bg-p-lightest lg:hidden overflow-hidden">
                <h4 class="body-14 text-t-foreground-secondary mb-xs">Popular filters</h4>
                <div class="flex [&amp;[loading]]:opacity-50 [&amp;[loading]]:pointer-events-none">
                    <form
                        class="overflow-x-auto"
                        onSubmit={e => e.preventDefault()}
                    >
                        <div class="flex items-center gap-xs w-full text-t-foreground overflow-auto pb-sm">
                            {finalFacets.map(facetName => {
                                const matchingFacet = facets.find(f => f.name.toLowerCase() === facetName.toLowerCase());
                                if(!matchingFacet) return null;
                                return (
                                    <div key={matchingFacet.id}>
                                        <div class="ns-popular-dropdown inline-block bg-t-background">
                                            <div class="inline-flex place-items-center">
                                                <button 
                                                    type="button" 
                                                    class="ns-popular-toggle flex w-full items-center justify-between border border-t-border-primary h-10 px-xs text-t-foreground"
                                                    id={`ns-filter-toggle-${matchingFacet.id}`} 
                                                    aria-expanded={activeDropdown === matchingFacet.id}
                                                    aria-controls={`ns-dropdown-panel-${matchingFacet.id}`}
                                                    onClick={() => setActiveDropdown(activeDropdown === matchingFacet.id ? null : matchingFacet.id)}
                                                >
                                                    <span class="body-14 whitespace-nowrap">{matchingFacet.name}</span>
                                                    <span class="ns-chevron-icon ml-sm flex items-center cursor-pointer text-t-brand-primary">
                                                        <span class="transition-rotate block w-full h-full">
                                                            <span class="block h-full w-full">
                                                                <svg aria-hidden="true" focusable="false" role="presentation" fill="none" class="icon icon-caret-down" id="icon-caret-down" viewBox="0 0 12 12">
                                                                    <path stroke="currentColor" d="M11.5 3.5 6 8.313.5 3.5"></path>
                                                                </svg>
                                                            </span>
                                                        </span>
                                                    </span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    </form>
                </div>
            </div>
            {finalFacets.map(facetName => {
                const matchingFacet = facets.find(f => f.name.toLowerCase() === facetName.toLowerCase());
                if(!matchingFacet) return null;
                return (
                    <div 
                        key={matchingFacet.id}
                        class="ns-popular-modal fixed inset-0 p-0 m-0 block z-100"
                        id={`ns-dropdown-panel-${matchingFacet.id}`}
                        aria-labelledby={`ns-filter-toggle-${matchingFacet.id}`}
                        aria-hidden={activeDropdown !== matchingFacet.id}
                        role="region"
                    >
                        <div class="ns-popular-modal-content drawer flex flex-col">
                            <div class="static bg-t-background !h3 text-t-foreground p-xs right-0 top-0 z-50 flex items-center justify-between bg-p-lightest lg:right-xs lg:top-xs">
                                <div class=" flex-grow">
                                    <h5 class="h5 flex items-center flex-wrap ">{matchingFacet.name}</h5>
                                </div>
                                <button
                                    type="button"
                                    class="ns-sidebar-close-btn focus-visible:ring-u-focus ml-auto inline-flex p-1 leading-none text-t-brand-primary focus:outline-none focus-visible:ring-1"
                                    aria-label="Close filter list"
                                    onClick={() => handleDropdownChange(matchingFacet.id)}
                                >
                                    <span class="block h-full w-full">
                                        <svg fill="none" id="icon-close" viewBox="0 0 20 20" role="presentation">
                                            <path stroke="currentColor" d="M16.93 17.212 2.788 3.07M3.283 17.425 17.425 3.282"></path>
                                        </svg>
                                    </span>
                                </button>
                            </div>
                            <div class="ns-popular-modal-list pb-4">
                                <div class="py-xs px-4 bg-p-lightest h-full min-w-60 group-open/filter-dropdown:absolute group-open/filter-dropdown:top-[120%] group-open/filter-dropdown:left-0">
                                    <FilterList facet={matchingFacet} />
                                </div>
                            </div>
                            <div class="sticky bottom-0 w-full py-xs px-sm gap-xs grid grid-cols-[68%_30%] justify-center bg-t-background border-t border-t-ui-lines-2 border-solid">
                                <button 
                                    type="button" 
                                    class="btn !min-w-none" 
                                    variant="primary"
                                    onClick={() => handleDropdownChange(matchingFacet.id)}
                                >
                                    Apply ({docCount})
                                </button>
                                <button 
                                    type="button" 
                                    class="btn !min-w-none !border !border-t-foreground bg-t-brand-primary-contrast !px-xs" 
                                    variant="tertiary"
                                    onClick={removeAll}
                                >
                                    Clear All
                                </button>
                            </div>
                        </div>
                    </div>
                )
            })}
        </>
    )
}
